import { Link } from "react-router-dom";
import React, { useState, useEffect } from "react";
import BootstrapTable from "react-bootstrap-table-next";
import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";
import Col from "react-bootstrap/Col";
import Container from "react-bootstrap/Container";
import Modal from "react-bootstrap/Modal";
import Row from "react-bootstrap/Row";
// import "../../../Utils/Csss/Style.css";
import toastr from "toastr";
import "toastr/build/toastr.min.css";
import {
  getAllDepts,
  deleteDept,
  getEmployeesWithNoDept,
  updateDept,
} from "../../../../services/RHService/DepartementService";
import paginationFactory from "react-bootstrap-table2-paginator";
import ToolkitProvider, {
  CSVExport,
} from "react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit.min";
import getCurrentUserId from "../../../../reduxSaga/sagas/requests/currentUserId";
import withLoader from "../../../../components/layouts/WithLoader";
const Departmentlist = ({ startLoading, stopLoading }) => {
  //variables
  const { ExportCSVButton } = CSVExport;
  const [showModifyform, setShowModifyform] = useState(false);
  const handleCloseModifyform = () => setShowModifyform(false);
  const [dept, setDept] = useState([]);
  const [selectedDept, setSelectedDept] = useState([]);
  const [employees, setEmployees] = useState([]);
  //   const [crews, setCrews] = useState([]);
  const fetchDepts = async () => {
    try {
      const names = await getAllDepts(getCurrentUserId());
      if (names.status === 200) {
        setDept(names.data?.success);
      } else if (names.error) {
        throw new Error(names.error);
      }
    } catch (error) {
      console.error(`Failed to fetch dept names: ${error}`);
    }
  };
  useEffect(() => {
    fetchDepts();
  }, []);
  //DEPT LIST
  useEffect(() => {
    const fetchData = async () => {
      try {
        startLoading()
        const resp = await getEmployeesWithNoDept(getCurrentUserId());

        if (resp) {
          setEmployees(resp.data?.success);
        }
      } catch (error) {
        console.error(error);
      } finally {
        stopLoading()
      }
    };

    fetchData();
  }, []);
  const handleDelete = async (idDept) => {
    await deleteDept(idDept, setDept);
  };
  //afficher les information a modifier par defaut dans le Model
  const handleShowModifyform = (dept) => {
    setSelectedDept(dept);
    setShowModifyform(true);
  };

  const handleUpdate = async (event) => {
    event.preventDefault();
    // console.log(selectedDept);
    try {
      if (selectedDept.nomDept === "" || !selectedDept.idEmployee) {
        toastr.error("Veillez renseigner tout les champs.");
        return;
      } else await updateDept(selectedDept.idDept, selectedDept);

      fetchDepts();
      handleCloseModifyform();
    } catch (error) {
      alert(error.message);
    }
  };
  //colonnes de tableau
  const columns = [
    {
      dataField: "id",
      text: "#",
      formatter: (cell, row, rowIndex, formatExtraData) => {
        return rowIndex + 1;
      },
    },
    { dataField: "nomDept", text: "Département" },
    {
      dataField: "chefdept",
      text: "Chef de département",
      formatter: (cell, row) => `${row.firstname} ${row.lastname}`,
    },
    { dataField: "phone", text: "Mobile" },
    { dataField: "email", text: "Email" },
    {
      dataField: "actions",
      text: "Actions",
      csvExport: false,
      formatter: (cell, row) => {
        return (
          <div className="center" style={{ display: "flex" }}>
            <Button
              style={{
                "background-color": "#000",
                color: "white",
                "border-color": "transparent",
                "border-radius": "0px",
              }}
              onClick={() => {
                handleShowModifyform(row);
              }}
            >
              <i className="fa-solid fa-pencil"></i>
            </Button>
            <Link to={`/crewByDept?idDept=${row.idDept}`}>
              <Button
                className="mx-1"
                style={{
                  "background-color": "#696969",
                  color: "white",
                  "border-color": "transparent",
                  "border-radius": "0px",
                }}
              >
                <i
                  class="fa-solid fa-eye eye-icon m-1"
                  style={{ color: "white" }}
                ></i>
              </Button>
            </Link>
            <Button
              style={{
                "background-color": "#cc0000",
                color: "white",
                "border-color": "transparent",
                "border-radius": "0px",
              }}
              onClick={() => {
                handleDelete(row.idDept);
              }}
            >
              <i className="fa-solid fa-trash-can"></i>
            </Button>
          </div>
        );
      },
    },
  ];

  //pagination options
  const paginationoptions = {
    sizePerPage: 5,
    hideSizePerPage: true,
    hidePageListOnlyOnePage: true,
    paginationPosition: "bottom",
  };

  // Filtrage par Dept
  const [filterData, setFilterData] = useState({});
  const handleChange = (event) => {
    const target = event.target;
    const value = target.type === "checkbox" ? target.checked : target.value;
    const name = target.name;
    setFilterData({
      ...filterData,
      [name]: value,
    });
  };
  const filteredData = dept.filter((d) => {
    const idDept = d.idDept.toString();
    if (
      filterData.idDept &&
      idDept !== filterData.idDept &&
      filterData.idDept !== "dept"
    ) {
      return false;
    }
    return true;
  });
  // Filtrage par Dept ***
  return (
    <div class="content-wrapper" style={{ marginTop: "0" }}>
      <ToolkitProvider
        keyField="id"
        data={filteredData}
        columns={columns}
        exportCSV={{
          fileName: "List Département.csv",
          onlyExportFiltered: true,
          exportAll: false,
        }}
      >
        {(props) => (
          <div>
            {/* Modify Crew Modal */}
            <Modal
              show={showModifyform}
              onHide={handleCloseModifyform}
              size="lg"
            >
              <Modal.Header closeButton>
                <Modal.Title>Modifier les informations</Modal.Title>
              </Modal.Header>
              <Modal.Body className="show-grid">
                <Form onSubmit={handleUpdate}>
                  <Container>
                    <Row>
                      <Col xs={12} md={12}>
                        <div className="form-group">
                          <label>Nom de département</label>
                          <input
                            type="text"
                            className="form-control form-control-border"
                            name="nomDept"
                            value={selectedDept ? selectedDept.nomDept : ""}
                            onChange={(e) =>
                              setSelectedDept({
                                ...selectedDept,
                                nomDept: e.target.value,
                              })
                            }
                          />
                        </div>

                        <div className="form-group">
                          <label>Chef de département</label>
                          <select
                            className="custom-select form-control-border"
                            name="idEmployee"
                            value={selectedDept ? selectedDept.idEmployee : ""}
                            onChange={(e) =>
                              setSelectedDept({
                                ...selectedDept,
                                idEmployee: e.target.value,
                              })
                            }
                          >
                            <option value="">
                              {selectedDept
                                ? selectedDept.firstname +
                                " " +
                                selectedDept.lastname
                                : "Select a chef de département"}
                            </option>
                            {employees.map((employee) => (
                              <option
                                key={employee.idEmployee}
                                value={employee.idEmployee}
                              >
                                {employee.firstname} {employee.lastname}
                              </option>
                            ))}
                          </select>
                        </div>
                      </Col>
                    </Row>
                  </Container>
                </Form>
              </Modal.Body>
              <Modal.Footer>
                <Button variant="secondary" onClick={handleCloseModifyform}>
                  Fermer
                </Button>
                <Button variant="dark" onClick={handleUpdate}>
                  Modifier
                </Button>
              </Modal.Footer>
            </Modal>
            {/* Modify Crew Modal */}
            <br />
            {/* header */}
            <section className="content ">
              <div class="container-fluid">
                <div class="card card-dark">
                  <div class="card-body">
                    <h5 class="card-title">Ajouter Département</h5>

                    <Link to="/addDepartment">
                      <button class="btn btn-dark  float-right">
                        <i class="fas fa-plus"></i>
                      </button>
                    </Link>
                  </div>
                </div>
              </div>
            </section>
            {/* header */}
            <div class="container-fluid">
              <div class="row">
                <div className="col-md-3 col-lg-3 col-sm-12 mb-2">
                  <ExportCSVButton
                    {...props.csvProps}
                    className="btn btn1 float-left"
                  >
                    Export CSV
                  </ExportCSVButton>
                </div>

                {/* buttons */}
                <div className="col-md-5 col-lg-5 col-sm-12 mb-2"></div>
                <div className="col-md-3 col-lg-3 col-sm-12 mb-2  ">
                  {/* filter by Dept */}
                  <Form.Group controlId="exampleForm.ControlSelect1 ">
                    <select
                      className="custom-select form-control-border "
                      name="idDept"
                      value={filterData.idDept}
                      onChange={handleChange}
                    >
                      <option value="dept" className="center">
                        -- Filtrer --
                      </option>
                      {dept.map((d) => (
                        <option key={d.idDept} value={d.idDept}>
                          {d.nomDept}
                        </option>
                      ))}
                    </select>
                  </Form.Group>
                  {/* filter by Dept */}
                </div>
                {/* <div className="col-md-3 col-lg-3 col-sm-12">
                  <Link to="/add_department">
                    {" "}
                    <button type="button" className="btn btn-dark float-right">
                      Ajouter Département
                    </button>
                  </Link>
                </div> */}

                <div class="col-md-12">
                  <div class="card">
                    <div class="container-fluid">
                      <div class="row">
                        <div class="card-header col-md-6 left">
                          <h3 class="card-title">Liste des Départements</h3>
                        </div>
                      </div>
                    </div>
                    <div class="card-body">
                      {/* table */}
                      <BootstrapTable
                        {...props.baseProps}
                        data={filteredData}
                        columns={columns}
                        pagination={paginationFactory(paginationoptions)}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
      </ToolkitProvider>
    </div>
  );
};

export default withLoader(Departmentlist);
